import { Box, IBoxProps, useToken } from 'native-base';
import React from 'react';

export type RadioIndicatorProps = {
  isSelected: boolean;
} & IBoxProps;

export default function RadioIndicator({ isSelected, ...props }: RadioIndicatorProps) {
  const [activeColor, muted300] = useToken('colors', ['brand.active', 'muted.300']);

  return (
    <Box
      alignItems="center"
      borderColor={isSelected ? activeColor : muted300}
      borderRadius="full"
      borderWidth="2"
      h="24px"
      justifyContent="center"
      w="24px"
      {...props}
    >
      {isSelected && <Box backgroundColor={activeColor} borderRadius="full" h="12px" w="12px" />}
    </Box>
  );
}
